import { THEMES } from "../config/theme";

/**
 * Returns the current org's branded theme tokens.
 * @returns {{ T: Object, headerBg: string }} Theme object and header background color
 */
export function useBrandedTheme() {
  // EXIQ is dark-mode only. T is always the dark theme.
  const T = THEMES.dark;
  const headerBg = THEMES.dark.headerBg;
  return { T, headerBg };
}
